<div class="dashboard-page container-page">
    <div class="title-page d-flex justify-content-between">
        <div class="title">
            Tạo kho hàng
        </div>
        <BreadcrumbComponent></BreadcrumbComponent>
    </div>
    <div style="background: #f7f8f9;height: 100%">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="search-component d-flex flex-wrap">
                        <div class="col-sm-12 d-flex justify-content-between flex-wrap">
                        </div>
                    </div>
                    <div class="list-arrivals-component">
                        <div class="col-sm-12 border border-3 rounded p-4">
                            <div class="col-sm-12">
                                <h4>THÔNG TIN KHO NHẬN HÀNG</h4>
                            </div>
                            <div class="col-sm-12 d-flex gap-3 flex-wrap">
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_to_name.label"
                                            :id="dataArrival.warehouse_to_name.id"
                                            :placeholder="dataArrival.warehouse_to_name.placeholder"
                                            :value-default="dataArrival.warehouse_to_name.value"
                                            @eventClick="showModalWarehouseList"
                                            :error-text="dataArrival.warehouse_to_name.error"
                                            :is-error="dataArrival.warehouse_to_name.isError"
                                            :required="dataArrival.warehouse_to_name.required"
                                            :readonly="dataArrival.warehouse_to_name.readonly"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_to_code.label"
                                            :id="dataArrival.warehouse_to_code.id"
                                            :placeholder="dataArrival.warehouse_to_code.placeholder"
                                            :value-default="dataArrival.warehouse_to_code.value"
                                            @inputValue="onChange($event, dataArrival.warehouse_to_code.id)"
                                            :error-text="dataArrival.warehouse_to_code.error"
                                            :is-error="dataArrival.warehouse_to_code.isError"
                                            @blur="validateForm($event, dataArrival.warehouse_to_code.id)"
                                            :required="dataArrival.warehouse_to_code.required"
                                            :readonly="dataArrival.warehouse_to_code.readonly"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_to_addr.label"
                                            :id="dataArrival.warehouse_to_addr.id"
                                            :placeholder="dataArrival.warehouse_to_addr.placeholder"
                                            :value-default="dataArrival.warehouse_to_addr.value"
                                            @inputValue="onChange($event, dataArrival.warehouse_to_addr.id)"
                                            :error-text="dataArrival.warehouse_to_addr.error"
                                            :is-error="dataArrival.warehouse_to_addr.isError"
                                            @blur="validateForm($event, dataArrival.warehouse_to_addr.id)"
                                            :required="dataArrival.warehouse_to_addr.required"
                                            :readonly="dataArrival.warehouse_to_addr.readonly"
                                    ></InputTextNormal>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 border border-3 rounded p-4 mt-4">
                            <div class="col-sm-12">
                                <h4>THÔNG TIN SẢN PHẨM</h4>
                            </div>
                            <div class="col-sm-12 d-flex gap-3 flex-wrap">
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.product_name_arrival.label"
                                            :id="dataArrival.product_name_arrival.id"
                                            :placeholder="dataArrival.product_name_arrival.placeholder"
                                            :value-default="dataArrival.product_name_arrival.value"
                                            @eventClick="showModalProductList"
                                            :error-text="dataArrival.product_name_arrival.error"
                                            :is-error="dataArrival.product_name_arrival.isError"
                                            :required="dataArrival.product_name_arrival.required"
                                            :readonly="dataArrival.product_name_arrival.readonly"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.product_code_arrival.label"
                                            :id="dataArrival.product_code_arrival.id"
                                            :placeholder="dataArrival.product_code_arrival.placeholder"
                                            :value-default="dataArrival.product_code_arrival.value"
                                            @inputValue="onChange($event, dataArrival.product_code_arrival.id)"
                                            :error-text="dataArrival.product_code_arrival.error"
                                            :is-error="dataArrival.product_code_arrival.isError"
                                            @blur="validateForm($event, dataArrival.product_code_arrival.id)"
                                            :required="dataArrival.product_code_arrival.required"
                                            :readonly="dataArrival.product_code_arrival.readonly"
                                    ></InputTextNormal>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 border border-3 rounded p-4 mt-4">
                            <div class="col-sm-12">
                                <h4>THÔNG TIN NHẬP HÀNG</h4>
                            </div>
                            <div class="col-sm-12 d-flex gap-3 flex-wrap">
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.product_quantity.label"
                                            :id="dataArrival.product_quantity.id"
                                            :placeholder="dataArrival.product_quantity.placeholder"
                                            :value-default="dataArrival.product_quantity.value"
                                            @inputValue="onChange($event, dataArrival.product_quantity.id)"
                                            :error-text="dataArrival.product_quantity.error"
                                            :is-error="dataArrival.product_quantity.isError"
                                            @blur="validateForm($event, dataArrival.product_quantity.id)"
                                            :required="dataArrival.product_quantity.required"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputDateTimeNormal
                                            :label="dataArrival.expected_arrival_date.label"
                                            :id="dataArrival.expected_arrival_date.id"
                                            :placeholder="dataArrival.expected_arrival_date.placeholder"
                                            :value-default="dataArrival.expected_arrival_date.value"
                                            @inputValue="onChange($event, dataArrival.expected_arrival_date.id)"
                                            :error-text="dataArrival.expected_arrival_date.error"
                                            :is-error="dataArrival.expected_arrival_date.isError"
                                            @blur="validateForm($event, dataArrival.expected_arrival_date.id)"
                                            :required="dataArrival.expected_arrival_date.required"
                                    ></InputDateTimeNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputDateTimeNormal
                                            :label="dataArrival.arrival_date.label"
                                            :id="dataArrival.arrival_date.id"
                                            :placeholder="dataArrival.arrival_date.placeholder"
                                            :value-default="dataArrival.arrival_date.value"
                                            @inputValue="onChange($event, dataArrival.arrival_date.id)"
                                            :error-text="dataArrival.arrival_date.error"
                                            :is-error="dataArrival.arrival_date.isError"
                                            @blur="validateForm($event, dataArrival.arrival_date.id)"
                                            :required="dataArrival.arrival_date.required"
                                    ></InputDateTimeNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputDateTimeNormal
                                            :label="dataArrival.expected_departure_date.label"
                                            :id="dataArrival.expected_departure_date.id"
                                            :placeholder="dataArrival.expected_departure_date.placeholder"
                                            :value-default="dataArrival.expected_departure_date.value"
                                            @inputValue="onChange($event, dataArrival.expected_departure_date.id)"
                                            :error-text="dataArrival.expected_departure_date.error"
                                            :is-error="dataArrival.expected_departure_date.isError"
                                            @blur="validateForm($event, dataArrival.expected_departure_date.id)"
                                            :required="dataArrival.expected_departure_date.required"
                                    ></InputDateTimeNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputDateTimeNormal
                                            :label="dataArrival.departure_date.label"
                                            :id="dataArrival.departure_date.id"
                                            :placeholder="dataArrival.departure_date.placeholder"
                                            :value-default="dataArrival.departure_date.value"
                                            @inputValue="onChange($event, dataArrival.departure_date.id)"
                                            :error-text="dataArrival.departure_date.error"
                                            :is-error="dataArrival.departure_date.isError"
                                            @blur="validateForm($event, dataArrival.departure_date.id)"
                                            :required="dataArrival.departure_date.required"
                                    ></InputDateTimeNormal>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 border border-3 rounded p-4 mt-4">
                            <div class="col-sm-12">
                                <h4>THÔNG TIN NƠI CUNG CẤP</h4>
                            </div>
                            <div class="col-sm-12 d-flex gap-3 flex-wrap">
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_from_name.label"
                                            :id="dataArrival.warehouse_from_name.id"
                                            :placeholder="dataArrival.warehouse_from_name.placeholder"
                                            :value-default="dataArrival.warehouse_from_name.value"
                                            @inputValue="onChange($event, dataArrival.warehouse_from_name.id)"
                                            :error-text="dataArrival.warehouse_from_name.error"
                                            :is-error="dataArrival.warehouse_from_name.isError"
                                            @blur="validateForm($event, dataArrival.warehouse_from_name.id)"
                                            :required="dataArrival.warehouse_from_name.required"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_from_code.label"
                                            :id="dataArrival.warehouse_from_code.id"
                                            :placeholder="dataArrival.warehouse_from_code.placeholder"
                                            :value-default="dataArrival.warehouse_from_code.value"
                                            @inputValue="onChange($event, dataArrival.warehouse_from_code.id)"
                                            :error-text="dataArrival.warehouse_from_code.error"
                                            :is-error="dataArrival.warehouse_from_code.isError"
                                            @blur="validateForm($event, dataArrival.warehouse_from_code.id)"
                                            :required="dataArrival.warehouse_from_code.required"
                                    ></InputTextNormal>
                                </div>
                                <div class="col-sm-3">
                                    <InputTextNormal
                                            :label="dataArrival.warehouse_from_addr.label"
                                            :id="dataArrival.warehouse_from_addr.id"
                                            :placeholder="dataArrival.warehouse_from_addr.placeholder"
                                            :value-default="dataArrival.warehouse_from_addr.value"
                                            @inputValue="onChange($event, dataArrival.warehouse_from_addr.id)"
                                            :error-text="dataArrival.warehouse_from_addr.error"
                                            :is-error="dataArrival.warehouse_from_addr.isError"
                                            @blur="validateForm($event, dataArrival.warehouse_from_addr.id)"
                                            :required="dataArrival.warehouse_from_addr.required"
                                    ></InputTextNormal>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 mt-4 d-flex justify-content-center" v-if="statusArrivalCurrent === AppConstant.STATUS_ARRIVAL_CREATE">
                            <div class="col-sm-2 d-flex flex-column justify-content-end">
                                <ButtonSearchComponent :label="labelButtonSetting" @click="createOrUpdateArrival"></ButtonSearchComponent>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ModalDeliveryProductListComponent
        @showModalProduct="showModalProduct($event)"
        @searchProduct="eventSearchProduct($event)"
        @listProductsSelectedCurrent="eventGetListProductsSelected($event)"
        :eventClickShowModal="eventClickShowModalProduct"
        :listProductsSelected="listProductsSelected"
        :typeSelectItem="typeSelectProduct"
></ModalDeliveryProductListComponent>
<ModalWarehouseListComponent
        @showModalWarehouse="showModalWarehouse($event)"
        @searchWarehouse="eventSearchWarehouse($event)"
        @listWarehousesSelectedCurrent="eventGetListWarehousesSelected($event)"
        :eventClickShowModal="eventClickShowModalWarehouse"
        :listWarehousesSelected="listWarehousesSelected"
        :typeSelectItem="typeSelectWarehouse"
></ModalWarehouseListComponent>
<LoadingComponent v-if="isLoading"></LoadingComponent>
